import { MapPin, SlidersHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';

type BillboardListToolbarProps = {
  city?: string;
  total?: number;
  activeFilterCount: number;
  onOpenFilters: () => void;
  sectionTitle?: string;
  showNearbyLink?: boolean;
};

export function BillboardListToolbar({
  city,
  total = 0,
  activeFilterCount,
  onOpenFilters,
  sectionTitle,
  showNearbyLink = false,
}: BillboardListToolbarProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 sm:gap-4">
      <div className="min-w-0 flex-1 text-left">
        <p className="text-[11px] font-extrabold tracking-[1.5px] text-[#6A6688] uppercase">
          Discover screens
        </p>
        <h1 className="mt-1 text-2xl font-extrabold tracking-[-0.5px] text-[#3A3660] sm:text-[32px]">
          {sectionTitle || (
            <>
              Showing{' '}
              <span className="text-[#3B66B8]">{total}</span> smart screens
              {city ? ` in ${city}` : ''}
            </>
          )}
        </h1>
      </div>

      <div className="flex shrink-0 items-center gap-2.5">
        {showNearbyLink ? (
          <Link
            to="/nearby-screens"
            className="inline-flex h-11 items-center justify-center gap-2 rounded-[14px] border border-[#D9D3F0] bg-white px-5 text-sm font-bold text-[#2B3E8A] shadow-sm transition hover:bg-[#F4F2FB]"
          >
            <MapPin size={16} className="text-[#8156B4]" />
            Nearby
          </Link>
        ) : null}

        <button
          type="button"
          onClick={onOpenFilters}
          className="inline-flex h-11 cursor-pointer items-center justify-center gap-2 rounded-full px-5 text-sm font-bold text-white shadow-sm transition hover:opacity-95"
          style={{ background: 'linear-gradient(180deg, #5F69A8, #474B8F)' }}
        >
          <SlidersHorizontal size={16} />
          Filters
          {activeFilterCount > 0 ? (
            <span className="rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-bold">
              {activeFilterCount}
            </span>
          ) : null}
        </button>
      </div>
    </div>
  );
}
